import { cloneElement } from 'react';

import styled from 'styled-components';
import ArrowIcon from 'mdi-react/ChevronRightIcon';

import { layout } from '@prisjakt/ui-base';

type MenuItemProps = {
  component: React.ReactElement;
};

// Cloning allows us to dynamically render an element based on its props
// For example: We render <a /> if we pass `href` to the component
//
// Only forwarding `rest` to the cloned element stops the Unknown Prop warnings
// in the test suites. Should be replaced by `shouldForwardProp` when this
// feature lands in Styled Components.
export const MenuItem = styled(({ type, ...rest }) => cloneElement(type, rest))<
  MenuItemProps
>`
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${layout.spacing.xSmall} ${layout.spacing.small};
  color: ${p => p.theme.text.primary};
  background: ${p => p.theme.bg.primary};
  transition: background ${layout.animations.buttonTransition};
  cursor: pointer;

  &:hover {
    background: ${p => p.theme.bg.secondary};
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${p => p.theme.lines.secondary};
  }
`;

export const Arrow = styled(ArrowIcon)`
  margin-left: auto;
`;
